const BlackListDashboard = () => import('@/components/blackLists/Dashboard.vue')
const BlackListInvoices = () => import('@/components/blackLists/Invoices.vue')
const BlackListRFCSearh = () => import('@/components/blackLists/RFCSearch.vue')
const BlackListMassiveRFCSearh = () => import('@/components/blackLists/MassiveRFCSearch.vue')
const BlackListRFCMonitoring = () => import('@/components/blackLists/MonitoringRFC.vue')

const blackListPermissions = [
  'dashboard_listas_negras',
  'cfdis',
  'busqueda_individual',
  'busqueda_masiva',
]

export const blackListRoutes = [
  {
    path: '/black-list',
    meta: { breadcrumb: 'Lista Negra SAT', requiresAuth: true, permissions: blackListPermissions },
    children: [
      { path: 'dashboard', component: BlackListDashboard, meta: { breadcrumb: 'Dashboard', permissions: [blackListPermissions[0]] } },
      { path: 'invoices', component: BlackListInvoices, meta: { breadcrumb: 'CFDIs', permissions: [blackListPermissions[1]] } },
      { path: 'rfc-search', component: BlackListRFCSearh, meta: { breadcrumb: 'Búsqueda Individual', permissions: [blackListPermissions[2]] } },
      { path: 'massive-rfc-search', component: BlackListMassiveRFCSearh, meta: { breadcrumb: 'Búsqueda Masiva', permissions: [blackListPermissions[3]] } },
      { path: 'rfc-monitoring', component: BlackListRFCMonitoring, meta: { breadcrumb: 'Monitoreo RFCs' } },
    ],
  }
]
